import type React from 'react'
import { File, MousePointer2, Shapes, Type } from 'lucide-react'
import { SpellCheckIcon } from '@/components/ui/custom-icons'

export interface SideNavItem {
  id: string
  Icon: React.ComponentType<{ className?: string }>
  label: string
  isActive?: boolean
  hasDropdown?: boolean
}

/** The left rail's tools, top to bottom. `id` is the `activeItem` value the tool activates. */
export const TOOL_RAIL_ITEMS: SideNavItem[] = [
  { id: 'select', Icon: MousePointer2, label: 'Select' },
  { id: 'type', Icon: Type, label: 'Type' },
  { id: 'shape', Icon: Shapes, label: 'Shapes' },
  { id: 'spellcheck', Icon: SpellCheckIcon, label: 'Spell Check' },
  { id: 'document', Icon: File, label: 'Document' },
]
